// extracted by mini-css-extract-plugin
module.exports = {"root":"Brainfish_root___ZzQ1"};